<template>
  <div class="c-entrepreneur-video | grid" :class="className">
    <!-- innter -->
    <ul class="c-entrepreneur-video__inner | t-content">
      <li class="c-entrepreneur-video__inner__title">
        <!-- title -->
        <prismic-rich-text v-if="data.primary.rich_title" :field="data.primary.rich_title" />
      </li>
      <!-- copy -->
      <li v-if="data.primary.desc" class="c-entrepreneur-video__inner__copy">
        <prismic-rich-text :field="data.primary.desc" />
      </li>
      <!-- video with decoration -->
      <li class="c-entrepreneur-video__inner__video">
        <entrepreneur-video-asset
          :image="data.primary.image"
          :video-id="data.primary.youtube_id"
          :video-description="data.primary.video_description"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import EntrepreneurVideoAsset from "components/EntrepreneurVideo/EntrepreneurVideoAsset";
import PrismicRichText from "objects/PrismicRichText";
export default {
  components: {
    EntrepreneurVideoAsset,
    PrismicRichText
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    bg: {
      type: String,
      required: false,
      default: "dark"
    }
  },
  computed: {
    className() {
      let classname = "c-entrepreneur-video";

      if (this.bg) {
        classname += ` c-entrepreneur-video--${this.bg}`;
      }

      return classname;
    }
  }
};
</script>

<style lang="scss" scoped>
.c-entrepreneur-video {
  @include sectionColouredPadding;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: var(--color-bg);

  --color-bg: #{$color-bright};
  --color-text: #{$color-dark};
  color: var(--color-text);

  &--bright {
    --color-bg: #{$color-bright};
    --color-text: #{$color-dark};
  }
  &--dark {
    --color-bg: #{$color-dark};
    --color-text: #{$color-bright};
  }

  /* padding is same as  sectionColouredPadding but the padding bottom disapears on mobile */
  padding: var(--grid-gutter-double) var(--grid-gutter) 0em var(--grid-gutter);
  margin-bottom: var(
    --grid-gutter-double
  ); // transfer the 3em padding bottom to the margin instead to leave space below
  @media #{$breakpoint-horizontal} {
    padding: var(--grid-gutter-double) 18vw var(--grid-gutter-double) 12vw;
    margin-bottom: 0em; // set back to value from sectionColouredPadding
  }

  &__inner {
    @include reset-list;
    display: flex;
    flex-flow: column wrap;
    max-width: 660px;
    gap: var(--grid-gutter-half);

    &__title {
      @include t3-heavy-bold;
      @include boldIsWhite;

      width: 100%;
    }
    &__video {
      width: calc(100% + var(--grid-gutter) * 2);
      margin-left: calc(0px - var(--grid-gutter));
      display: flex;
      justify-content: center;

      @media #{$breakpoint-horizontal} {
        width: 100%;
        margin-left: 0px;
      }
    }

    &__copy {
      padding-right: var(--grid-gutter-double);
      &::v-deep h3 {
        @include t3-light;
        /* font-size: 1.6em; */
      }

      @media #{$breakpoint-vertical} {
        margin-top: 0rem; //overwrite code use somewhere else
      }

      &::v-deep p {
        margin-top: var(--grid-gutter);
        @media #{$breakpoint-horizontal} {
          margin-top: 0rem;
        }
      }
    }
  }
}
</style>
